import vSearchableSelectAddress from "./v-searchable-select-address.vue";

export default Vue => {
  Vue.component("v-searchable-select-address", vSearchableSelectAddress);
};
